import en from './en.json'
import it from './it.json'

export const defaultLocale = 'it';

/* Lingue disponibili per l'applicazione, per essere abilitata va importato il file json corrispondente  */
export const languages = {
  en: en,
  it: it,
};

/* Lingue disponibili per l'utente, sono le lingue attivabili dal profilo dell'utente */
export const langPage = [
    { language: "en", title: "English" },
    { language: "it", title: "Italiano" }
];
